import React from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import { withStyles} from '@material-ui/core/styles'
import {
  Grid, Table, TableHeaderRow
} from '@devexpress/dx-react-grid-material-ui'

const styles = {
  customCell: {
    whiteSpace: "normal",
    wordWrap: "break-word"
  }
}

const CustomTableCellBase = ({ classes, ...restProps }) => (
  <Table.Cell className={classes.customCell} {...restProps} />
)

const CustomTableBase = ({ style, ...restProps }) => (
  <Table.Table
    style={{
      ...style,
      minWidth: 0
    }}
    {...restProps}
  />
)

const CustomTableCell = withStyles(styles)(CustomTableCellBase);
const CustomTable = withStyles(styles)(CustomTableBase);

class LangTable extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: "actionColumn", title: "Language Settings" },
        { name: "descriptionColumn", title: "Description" }
      ],
      rows: [
        { actionColumn: 'Language: Deutsch', descriptionColumn: 'The user interface will be displayed in German' },
        { actionColumn: 'Language: English', descriptionColumn: 'The user interface will be displayed in English' },
        { actionColumn: 'Language: Français', descriptionColumn: 'The user interface will be displayed in French' },
        { actionColumn: 'Language: Polski', descriptionColumn: 'The user interface will be displayed in Polish' },
        { actionColumn: 'Language: Español', descriptionColumn: 'The user interface will be displayed in Español' },
        { actionColumn: 'Language: Italiano', descriptionColumn: 'The user interface will be displayed in Italiano' },
        { actionColumn: 'Language: Nederlands', descriptionColumn: 'The user interface will be displayed in Nederlands' },
        { actionColumn: 'Language: Português', descriptionColumn: 'The user interface will be displayed in Português' },
        { actionColumn: 'Language: Svenska', descriptionColumn: 'The user interface will be displayed in Svenska' },
        { actionColumn: 'Language: Türk', descriptionColumn: 'The user interface will be displayed in Türk' },
        { actionColumn: 'Language: 日本語', descriptionColumn: 'The user interface will be displayed in Japanese' },
        { actionColumn: 'Language: 中文(简体)', descriptionColumn: 'The user interface will be displayed in Chinese' },
        { actionColumn: 'Language: بالعربية', descriptionColumn: 'The user interface will be displayed in Arabic' },
        { actionColumn: 'Language: Русский', descriptionColumn: 'The user interface will be displayed in Russian' },
      ]
    };
  }
  render() {
    const { rows, columns } = this.state;

    return (
      <Paper style={{display: 'inline-block', maxWidth: '915px'}}>
        <Grid rows={rows} columns={columns}>
          <Table tableComponent={CustomTable} cellComponent={CustomTableCell} />
          <TableHeaderRow />
        </Grid>
      </Paper>
    );
  }
}

LangTable.propTypes = {
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(LangTable)